import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppState } from '../../config/state';
import moment from 'moment';
import { Platform, LoadingController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { ToastAlertsProvider } from '../toast-alerts/toast-alerts';
import { ApiProvider } from '../api/api';

/*
  Generated class for the DigitalItemsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DigitalItemsProvider {

  constructor(public http: HttpClient, private api: ApiProvider, private state : AppState, private platform: Platform, private inAppBrowser: InAppBrowser, private toast : ToastAlertsProvider, private loading: LoadingController) {
  }

  private filterBibId(item, service):Promise<any>{
    let idraw, id;
    switch(service){
      case 'overdrive':
        idraw = item.ids ? item.ids.filter(a => a.type.toLowerCase() == service) : '';
      break;
      default:
        idraw = item.ids ? item.ids.filter(a => a.type.toLowerCase() == 'marc'): '';
      break;
    }
    if (idraw.length > 0){
      id = idraw[0].id;
    } else {
      id = item.id;
    }
    return id;
  }

  public async getHooplaItemDetails(id) {
    const query = `{
      hooplaItemDetails(itemId: "${id}"){
        id
        ids { type id }
        title
        format
        source
        imageLinks { url }
        previewLink
        series
        author
        authors
        publisher
        language
        publishYear
        isbns
      }
    }`;
    let res = await this.api.query(query);
    return res && res.hooplaItemDetails ? res.hooplaItemDetails : null;
  }

  private async getHooplaCheckouts(barcode, pin):Promise<any>{
    return fetch(`https://api.communico.co/v2/${this.state.client.keyword}/hoopla/patron/checkouts/${barcode}/${pin}`).then(res => res.json()).then(result =>{
      // console.log(result);
      if(result.status!=="success")return [];
      if(!result.data)return [];
      return result.data.map(t => {
        return {
          "id": t.contentId,
          "dueDate": moment.unix(t.due).format("YYYY-MM-DD"),
          "outDate": moment.unix(t.borrowed).format("YYYY-MM-DD"),
          "barcode": null,
          "renewals": null,
          "bib": {
            "id": t.contentId,
            "ids":[{ "type": 'MARC', "id": t.contentId }],
            "title": t.title,
            "author": null,
            "authors": null,
            "publisher": null,
            "publishYear": null,
            "pageCount": null,
            "averageRating": null,
            "ratingsCount": null,
            "readingModes": { "text": null, "image": null },
            "available": null,
            "format": t.kind,
            "language": null,
            "previewLink": t.url,
            "imageLinks": [{ "type": null, "url": null}],
            "isbns": [],
            "upcs": [],
            "subjects": null,
            "summaries": [],
            "series": [],
            "notes": [],
            "src":"hoopla",
            "reviews": null
          }
        }
      });
    });
  }

  private getOverdriveCheckouts(barcode, pin):Promise<Array<any>>{
    return fetch(`https://api.communico.co/v1/${this.state.client.keyword}/overdrive/checkouts/${barcode}/${pin}`).then(res => res.json()).then(result =>{
      if(result.result!=="ok")return false;
      if (result.data.totalItems===0) return [];
        return result.data.checkouts.map(t => {
          return {
            "id": t.reserveId,
            "dueDate": t.expires,
            "outDate": t.checkoutDate,
            "barcode": null,
            "renewals": null,
            "bib": {
              "id": t.reserveId,
              "ids":[{ "type": 'MARC', "id": t.details.crossRefId }],
              "title": t.details.title,
              "author": t.details.creators[0].name,
              "authors": t.details.creators,
              "publisher": t.details.publisher,
              "publishYear": moment(t.details.publishDate).year(),
              "pageCount": null,
              "averageRating": t.details.starRating,
              "ratingsCount": null,
              "readingModes": { "text": null, "image": null },
              "available": t.details.isOwnedByCollections,
              "format": t.details.mediaType,
              "language": t.details.languages,
              "previewLink": t.details.links.self.href,
              "imageLinks": [{ "type": null, "url": t.details.images.cover.href}],
              "isbns": [],
              "upcs": [],
              "subjects": t.details.subjects,
              "summaries": [t.details.shortDescription],
              "series": [],
              "notes": [],
              "src":"overdrive",
              "reviews": t.details.reviews
            }
          }
        });
    });
  }
  async getDigitalCheckouts(barcode, pin):Promise<any> {
    let params = `barcode:"${barcode}"`;
    if (pin) params += ` pin: "${pin}"`;
    const query = `{
      patronDetails(${params}){
        digitalCheckouts {
          id
          dueDate
          bib {
              id
              ids { type id }
              title
              author
              authors
              publisher
              publishYear
              averageRating
              format
              language
              previewLink
              imageLinks { url }
              subjects
              summaries { text source }
              source
          }
        }
      }
    }`;
    let res = await this.api.query(query);
    return (res && res.patronDetails && res.patronDetails.digitalCheckouts) ? res.patronDetails.digitalCheckouts : [];
  }
  legacyGetDigitalCheckout(service, barcode, pin?):Promise<any>{
    switch(service){
      case 'hoopla':
        return this.getHooplaCheckouts(barcode, pin || '1234');
      case 'overdrive':
        return this.getOverdriveCheckouts(barcode, pin || '1234');
      default:
        return null;
    }
  }
  async getDigitalHolds(barcode, pin):Promise<any> {
    let params = `barcode:"${barcode}"`;
    if (pin) params += ` pin: "${pin}"`;
    const query = `{
      patronDetails(${params}){
        digitalHolds {
          id
          postion
          queueLength
          status
          frozen
          isReady
          isCancelled
          holdDate
          bib {
              id
              ids { type id }
              title
              author
              authors
              publisher
              publishYear
              averageRating
              format
              language
              previewLink
              imageLinks { url }
              subjects
              summaries { text source }
              source
          }
        }
      }
    }`;
    let res = await this.api.query(query);
    return (res && res.patronDetails && res.patronDetails.digitalHolds) ? res.patronDetails.digitalHolds : [];
  }
  legacyGetDigitalHolds(service, barcode, pin?):Promise<any>{
    switch(service){
      // case 'hoopla':
        // return this.getHooplaHolds(barcode, pin || '1234');
      case 'overdrive':
        return this.getOverdriveHolds(barcode, pin || '1234');
      default:
        return null;
    }
  }
  checkoutDigitalItem(service, item, barcode, pin?):Promise<any>{
    let id = this.filterBibId(item,service);
    switch(service){
      case 'hoopla':
        return this.checkoutHooplaItem(id, barcode, pin);
      case 'overdrive':
        return this.checkoutOverdriveItem(id, barcode, pin);
      default:
        return null;
    }
  }
  checkInDigitalItem(service, item, barcode, pin?):Promise<any>{
    let id = this.filterBibId(item,service);
    switch(service){
      case 'hoopla':
        return this.checkInHooplaItem(id, barcode, pin);
      case 'overdrive':
        return this.checkInOverdriveItem(id, barcode, pin);
      default:
        return null;
    }
  }
  readNow(service, item, barcode, pin?){
    let id = this.filterBibId(item,service);
    switch(service){
      case 'hoopla':
        this.inAppBrowser.create(item.previewLink, "_system");
      break;
      case 'overdrive':
        this.readNowOverdrive(id,barcode, pin);
      break;
      default:
        return null;
    }
  }
  cancelHolds(service, item, barcode, pin?){
    let id = this.filterBibId(item, service);
    switch(service){
      case 'overdrive':
        return this.cancelOverdriveHold(item,barcode, pin || '1234');
      default:
        return null;
    }
  }

  //GETTING HOLDS

  private async getOverdriveHolds(barcode, pin):Promise<Array<any>>{
    const result = await fetch(`https://api.communico.co/v1/${this.state.client.keyword}/overdrive/holds/${barcode}/${pin}`).then(res => res.json());

      // console.log(result)
      if(result.result!=="ok")return null;
      if (result.data.totalItems===0) return [];
      return Promise.all(result.data.holds.map(async h=>{
      // const pArray = result.data.holds.map(ayh=>{
        const response = await fetch(`https://api.communico.co/v1/${this.state.client.keyword}/overdrive/metadata/${h.reserveId}`).then(r => r.json()).then(hold =>{
          if (hold.result!=='ok') return false;
          if (hold.data.errorCode) return false;
            return {
              "id": h.reserveId,
              "status": 'On Hold',
              "frozen":false,
              "postion": h.holdListPosition,
              "holdDate": h.holdPlacedDate,
              "queueLength": h.numberOfHolds,
              "bib":{
                "id": h.reserveId,
                "ids":[{ "type": 'MARC', "id": hold.data.crossRefId }],
                "title": hold.data.title,
                "author": hold.data.creators[0].name,
                "authors": hold.data.creators,
                "publisher": hold.data.publisher,
                "publishYear": moment(hold.data.publishDate).year(),
                "pageCount": null,
                "averageRating": hold.data.starRating,
                "ratingsCount": null,
                "readingModes": { "text": null, "image": null },
                "available": hold.data.isOwnedByCollections,
                "format": hold.data.mediaType,
                "language": hold.data.languages,
                "previewLink": hold.data.links.self.href,
                "imageLinks": [{ "type": null, "url": hold.data.images.cover.href}],
                "isbns": [],
                "upcs": [],
                "subjects": hold.data.subjects,
                "summaries": [hold.data.shortDescription],
                "series": [],
                "notes": [],
                "src":"overdrive",
                "reviews": hold.data.reviews
              }
            }
        }).catch(err => {return false});
        return response
      })
    );
  }

  //CHECKING OUT ITEMS
  async checkoutOverdriveItem(itemId, barcode, pin):Promise<any>{
    let params = `barcode:"${barcode}" pin:"${pin}" itemId:"${itemId}"`;
    const query = `mutation {
      overdriveCheckoutItem(${params}) {
        status message
      }
    }`;
    const res = await this.api.query(query);
    return res.overdriveCheckoutItem || null;
  }

  private async checkoutHooplaItem(itemId, barcode, pin):Promise<any> {
    let params = `barcode:"${barcode}" pin:"${pin}" itemId:"${itemId}"`;
    const query = `mutation {
      hooplaCheckoutItem(${params}) {
        status message url
      }
    }`;
    const res = await this.api.query(query);
    return res.hooplaCheckoutItem || null;
  }

  // PLACING HOLDS
  public async overdrivePlaceHold(itemId, barcode, pin, email) {
    const params = `barcode:"${barcode}" pin:"${pin}" itemId:"${itemId}" email:"${email}"`;
    const query = `mutation {
      overdrivePlaceHold(${params}) {
        status message
      }
    }`;
    const res = await this.api.query(query);
    return res.overdrivePlaceHold || null;
  }

  // CANCELLING HOLDS
  async cancelOverdriveHold(itemId, barcode, pin):Promise<any>{
    const params = `barcode:"${barcode}" pin:"${pin}" itemId:"${itemId}"`;
    const query = `mutation {
      overdriveCancelHold(${params}) {
        status message
      }
    }`;
    const res = await this.api.query(query);
    return res.overdriveCancelHold || null;
  }

  // FREEZING HOLDS
  public async freezeOverdriveHold(itemId, barcode, pin, email) {
    const params = `barcode:"${barcode}" pin:"${pin}" itemId:"${itemId}" email:"${email}"`;
    const query = `mutation {
      overdriveSuspendHold(${params}) {
        status message
      }
    }`;
    const res = await this.api.query(query);
    return res.overdriveSuspendHold || null;
  }

  public async unfreezeOverdriveHold(itemId, barcode, pin) {
    const params = `barcode:"${barcode}" pin:"${pin}" itemId:"${itemId}"`;
    const query = `mutation {
      overdriveResumeHold(${params}) {
        status message
      }
    }`;
    const res = await this.api.query(query);
    return res.overdriveResumeHold || null;
  }

  //CHECKING IN ITEMS
  private async checkInOverdriveItem(itemId, barcode, pin):Promise<any>{
    const params = `barcode:"${barcode}" pin:"${pin}" itemId:"${itemId}"`;
    const query = `mutation {
      overdriveReturnItem(${params}) {
        status message
      }
    }`;
    const res = await this.api.query(query);
    return res.overdriveReturnItem || null;
  }

  private async checkInHooplaItem(itemId, barcode, pin):Promise<any>{
    let params = `barcode:"${barcode}" pin:"${pin}" itemId:"${itemId}"`;
    const query = `mutation {
      hooplaReturnItem(${params}) {
        status message
      }
    }`;
    const res = await this.api.query(query);
    return res.hooplaReturnItem || null;
  }

  //DOWNLOAD AND READ ITEMS NOW

  private async readNowOverdrive(itemId, barcode, pin){
    let loader = this.loading.create({content: 'Retrieving item data...'});
    loader.present();
    const params = `barcode:"${barcode}" pin:"${pin}" itemId:"${itemId}"`;
    const query = `{
      overdriveReadNow(${params}) {
        status message url
      }
    }`;
    const res = await this.api.query(query);
    if(res && res.overdriveReadNow && res.overdriveReadNow.status) {
      this.inAppBrowser.create(res.overdriveReadNow.url, "_system");
    } else {
      const message = res && res.overdriveReadNow && res.overdriveReadNow.message ? res.overdriveReadNow.message : 'Failed to retrieve item info';
      this.toast.showAlert('', message, '', 5000);
    }
    loader.dismiss();
  }

  public async getOverdriveItemAvailability(itemId) {
    const query = `{
      overdriveItemAvailability(itemId: "${itemId}") {
        available copiesOwned copiesAvailable numberOfHolds availabilityType
      }
    }`;
    const res = await this.api.query(query);
    return res.overdriveItemAvailability || null;
  }

}



// WEBPACK FOOTER //
// ./src/providers/digital-items/digital-items.ts